import * as Sentry from '@sentry/browser'
import { Vue as VueIntegration } from '@sentry/integrations'

export default {
  install (Vue) {
    const __DEV__ = process.env.NODE_ENV !== 'production'

    !__DEV__ && Sentry.init({
      dsn: process.env.VUE_APP_SENTRY_DSN,
      integrations: [new VueIntegration({ Vue, attachProps: true, logErrors: true })]
    })

    /** Attach Sentry instance to Vue prototype */
    Vue.prototype.$sentry = __DEV__ ? $sentry : Sentry
  }
}

/** Sentry stub for non-production environemnt */
const $sentry = {
  captureException (_error) {
    return null
  }
}
